import { render, staticRenderFns } from "./Neurology.vue?vue&type=template&id=22b09454&scoped=true"
import script from "./Neurology.vue?vue&type=script&lang=js"
export * from "./Neurology.vue?vue&type=script&lang=js"
import style0 from "./Neurology.vue?vue&type=style&index=0&id=22b09454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b09454",
  null
  
)

export default component.exports